<template>
<div class="ThePublicPush">
</div>
</template>

<script>
export default {
    name: 'ThePublicPush',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ThePublicPush {
}
</style>
